var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9035 8.04547C34.927 8.38586 34.927 8.72626 34.927 9.06979C34.927 19.5372 26.9383 31.6094 12.3306 31.6094V31.6031C8.01547 31.6094 3.78995 30.3765 0.157288 28.0517C0.784747 28.127 1.41535 28.1647 2.04753 28.1663C5.62358 28.1694 9.09741 26.9725 11.9108 24.7686C8.51241 24.7043 5.53237 22.4941 4.49132 19.2674C5.68176 19.4965 6.90838 19.4494 8.0768 19.131C4.3718 18.3843 1.70628 15.1372 1.70628 11.3663C1.70628 11.3317 1.70628 11.2988 1.70628 11.2659C2.81023 11.8792 4.04628 12.2196 5.31063 12.2572C1.82108 9.93096 0.745433 5.30037 2.85269 1.67998C6.88479 6.629 12.8339 9.63763 19.2201 9.95606C18.5801 7.20469 19.4544 4.32155 21.5176 2.38743C24.7163 -0.611784 29.747 -0.458058 32.7537 2.73096C34.5323 2.38116 36.237 1.73018 37.797 0.807824C37.2041 2.64155 35.9634 4.1992 34.3059 5.189C35.88 5.0039 37.418 4.58351 38.8664 3.94194C37.8001 5.53567 36.4572 6.9239 34.9035 8.04547Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo1);
export default __webpack_public_path__ + "static/media/Twitter-logo-1.8cb0ee5120056cd700da288f4d2b8d3b.svg";
export { ForwardRef as ReactComponent };